// @ts-check
import React from 'react'
import { time as uniqid } from 'uniqid'
import { Label } from '..'
import styles from './style.css'

/**
 * @param {{
 * children: React.ReactChild,
 * label?: string,
 * name: string,
 * onChange: {(event: React.ChangeEvent): void},
 * isChecked: boolean}} props
 */
const Checkbox = ({ label, name, onChange, children, isChecked }) => {
  const htmlFor = uniqid()

  return (
    <div className={styles.field}>
      {label && (
        <Label htmlFor={htmlFor} value={label} className={styles.label} valid={isChecked} />)}
      <label className={styles.wrapper}>
        <input
          type='checkbox'
          id={htmlFor}
          name={name}
          onChange={onChange}
          className={styles.checkbox}
          checked={isChecked}
        />
        <span className={styles.text}>{children}</span>
      </label>
    </div>)
}

export { Checkbox }
